/**
 * Track image helpers — ported from racore-app/utils/imageHelpers.
 */
import type { DiscoverTrack, Track } from '@/types';

export const getTrackImageUrl = (
  track: Track | DiscoverTrack | null | undefined,
): string | null => {
  if (!track) return null;

  if ('album' in track) {
    if (track.album?.image_xl) {
      return track.album.image_xl.trim() !== '' ? track.album.image_xl : null;
    }
    if (track.album?.image) {
      return track.album.image.trim() !== '' ? track.album.image : null;
    }
  }

  const imageUrl =
    ('metadata' in track ? track.metadata?.big_illustration_url : undefined) ||
    ('main_illustration_url' in track ? track.main_illustration_url : undefined);
  return imageUrl && imageUrl.trim() !== '' ? imageUrl : null;
};

export const isValidImageUrl = (url: string | null | undefined): boolean =>
  Boolean(url && url.trim() !== '');

/**
 * The backend stores the track image in `metadata.big_illustration_url`.
 * Mirror the legacy transform so created recommendations keep their artwork.
 */
export const transformTrackForBackend = (
  track: Track | DiscoverTrack | null | undefined,
): Record<string, unknown> | null | undefined => {
  if (!track) return track;
  const imageUrl = getTrackImageUrl(track);
  if (!imageUrl) return track as unknown as Record<string, unknown>;

  const album = 'album' in track ? track.album : undefined;
  const metadata = 'metadata' in track ? track.metadata : undefined;
  const bpm = 'bpm' in track ? track.bpm : undefined;

  const baseTrack = {
    ...track,
    album: { ...album, image: imageUrl },
  };

  return {
    ...baseTrack,
    metadata: {
      ...(metadata ?? {}),
      big_illustration_url: imageUrl,
      ...(bpm ? { bpm } : {}),
    },
  };
};
